import React from 'react';
import {useRegistryProject} from '../RegistryProjectContext';
import {MCPDiscoveryPageRegistry} from './MCPDiscoveryPageRegistry';

export const RegistryMCPDiscoveryPage = () => {
  const {project, subProject} = useRegistryProject();
  return <MCPDiscoveryPageRegistry project={project} subProject={subProject} />;
};
